<template>
    <b-card title="Newsletter Edit">
        <div style="width: 100%;">
            <div class="main-div-layout">
                <div class="main-template-layout" v-if="test">
                    <div class="big-screen-width">
                        <b-form-input v-model="subject" type="text" placeholder="Enter email subject"></b-form-input>
                    </div>

                    <div v-for="(fo, index) in layouts" :key="index">
                        <div>
                            <div style="display: flex; gap: 4px; margin-bottom: 12px;">
                                <div class="big-screen-width">
                                    <div>
                                        <b-form-select v-model="fo.template">
                                            <b-form-select-option v-for="option in options" :value="option.value">{{ option.title }}</b-form-select-option>
                                        </b-form-select>
                                    </div>
                                </div>
                    
                                <div style="width: 20%; display: flex; align-items: center;">
                                    <!-- Add Svg Icon -->
                                    <svg @click="addField(input, layouts)" width="24" height="24"
                                        class="cursor-pointer" style="cursor: pointer; margin-right: 2px;">
                                        <path fill="none" d="M0 0h24v24H0z"/>
                                        <path fill="#0397d6"
                                            d="M11 11V7h2v4h4v2h-4v4h-2v-4H7v-2h4zm1 11C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"/>
                                    </svg>
                    
                                    <!-- Remove Svg Icon -->
                                    <svg v-show="layouts.length > 1" @click="removeField(index, layouts)"
                                        width="24" height="24" style="cursor: pointer; margin-left: 2px;">
                                        <path fill="none" d="M0 0h24v24H0z"/>
                                        <path fill="#b91c1c"
                                            d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z"/>
                                    </svg>

                                    <div @click="moveItemUp(index)" style="margin: 0px 6px; cursor: pointer;">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-up"><line x1="12" y1="19" x2="12" y2="5"></line><polyline points="5 12 12 5 19 12"></polyline></svg>
                                    </div>
                                    
                                    <div @click="moveItemDown(index)" style="cursor: pointer;"> 
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-down"><line x1="12" y1="5" x2="12" y2="19"></line><polyline points="19 12 12 19 5 12"></polyline></svg>
                                    </div>
                                </div>
                            </div>

                            <div style="display: flex; flex-direction: column; gap: 12px;" class="section-screen" v-if="fo.template == 1">
                                <div class="w-fullbg-white rounded-sm">
                                    <b-form-input v-model="fo.title" type="text" placeholder="Enter title"></b-form-input>
                                </div>
                                <div class="w-fullbg-white rounded-sm">
                                    <vue-editor rows="5" v-model="fo.details" placeholder="Enter details"></vue-editor> 
                                </div>
                                <div class="w-fullbg-white rounded-sm"> 
                                    <div style="display: flex; gap: 16px; align-items: center;">
                                        <b-form-input v-model="fo.link" type="text" placeholder="Enter button link"></b-form-input>
                                        <b-button style="height: 38px;" v-b-modal.bv-modal-blog-xl @click="getBlog(fo)">Select</b-button>
                                    </div>
                                </div>
                            </div>   
                            <div style="display: flex; flex-direction: column; gap: 12px;" class="section-screen" v-if="fo.template == 2">
                                <div class="w-fullbg-white rounded-sm">
                                    <div style="display: flex; gap: 16px; align-items: center;">
                                        <img v-if="fo.image" style="height: 160px; max-width: 75%;" :src="fo.image" alt="">
                                        <b-button style="height: 40px;" v-b-modal.bv-modal-example-xl @click="getImage(fo)">Select Image</b-button>
                                    </div>
                                </div> 
                                <div class="w-fullbg-white rounded-sm">
                                    <b-form-input v-model="fo.caption" type="text" placeholder="Enter image caption"></b-form-input>
                                </div>
                                <div class="w-fullbg-white rounded-sm">
                                    <b-form-input v-model="fo.title" type="text" placeholder="Enter title"></b-form-input>
                                </div>
                                <div class="w-fullbg-white rounded-sm">
                                    <vue-editor rows="5" v-model="fo.details" placeholder="Enter details"></vue-editor> 
                                </div>
                                <div class="w-fullbg-white rounded-sm">
                                    <div style="display: flex; gap: 16px; align-items: center;">
                                        <b-form-input v-model="fo.link" type="text" placeholder="Enter button link"></b-form-input>
                                        <b-button style="height: 38px;" v-b-modal.bv-modal-blog-xl @click="getBlog(fo)">Select</b-button>
                                    </div>
                                </div>
                            </div>
                            <div style="display: flex; flex-direction: column; gap: 12px;" class="section-screen" v-if="fo.template == 3">
                                <div class="w-fullbg-white rounded-sm">
                                    <div style="display: flex; gap: 16px; align-items: center;">
                                        <img v-if="fo.image" style="height: 160px; max-width: 75%;" :src="fo.image" alt="">
                                        <b-button style="height: 40px;" v-b-modal.bv-modal-example-xl @click="getImage(fo)">Select Image</b-button>
                                    </div>
                                </div>
                                <div class="w-fullbg-white rounded-sm">
                                    <b-form-input v-model="fo.caption" type="text" placeholder="Enter image caption"></b-form-input>
                                </div>
                                <div class="w-fullbg-white rounded-sm">
                                    <b-form-input v-model="fo.title" type="text" placeholder="Enter title"></b-form-input>
                                </div>
                                <div class="w-fullbg-white rounded-sm">
                                    <vue-editor rows="5" v-model="fo.details" placeholder="Enter details"></vue-editor> 
                                </div>
                                <div class="w-fullbg-white rounded-sm">
                                    <div style="display: flex; gap: 16px; align-items: center;">
                                        <b-form-input v-model="fo.link" type="text" placeholder="Enter button link"></b-form-input>
                                        <b-button style="height: 38px;" v-b-modal.bv-modal-blog-xl @click="getBlog(fo)">Select</b-button>
                                    </div>
                                </div>
                            </div>
                            <div style="display: flex; flex-direction: column; gap: 12px;" class="section-screen" v-if="fo.template == 4">
                                <div class="w-fullbg-white rounded-sm">
                                    <div style="display: flex; gap: 16px; align-items: center;">
                                        <img v-if="fo.image" style="height: 160px; max-width: 75%;" :src="fo.image" alt="">
                                        <b-button style="height: 40px;" v-b-modal.bv-modal-example-xl @click="getImage(fo)">Select Image</b-button>
                                    </div>
                                </div>
                                <div class="w-fullbg-white rounded-sm">
                                    <b-form-input v-model="fo.caption" type="text" placeholder="Enter image caption"></b-form-input>
                                </div>
                                <div class="w-fullbg-white rounded-sm">
                                    <b-form-input v-model="fo.title" type="text" placeholder="Enter title"></b-form-input>
                                </div>
                                <div class="w-fullbg-white rounded-sm">
                                    <vue-editor rows="5" v-model="fo.details" placeholder="Enter details"></vue-editor> 
                                </div>
                                <div class="w-fullbg-white rounded-sm">
                                    <div style="display: flex; gap: 16px; align-items: center;">
                                        <b-form-input v-model="fo.link" type="text" placeholder="Enter button link"></b-form-input>
                                        <b-button style="height: 38px;" v-b-modal.bv-modal-blog-xl @click="getBlog(fo)">Select</b-button>
                                    </div>
                                </div>
                            </div>
                            <div style="display: flex; flex-direction: column; gap: 12px;" class="section-screen" v-if="fo.template == 5">
                                <div class="w-fullbg-white rounded-sm">
                                    <div style="display: flex; gap: 16px; align-items: center;">
                                        <img v-if="fo.image" style="height: 160px; max-width: 75%;" :src="fo.image" alt="">
                                        <b-button style="height: 40px;" v-b-modal.bv-modal-example-xl @click="getImage(fo)">Select Image</b-button>
                                    </div>
                                </div>
                                <div class="w-fullbg-white rounded-sm">
                                    <b-form-input v-model="fo.caption" type="text" placeholder="Enter image caption"></b-form-input>
                                </div>
                                <div class="w-fullbg-white rounded-sm">
                                    <b-form-input v-model="fo.title" type="text" placeholder="Enter title"></b-form-input>
                                </div>
                                <div class="w-fullbg-white rounded-sm">
                                    <vue-editor rows="5" v-model="fo.details" placeholder="Enter details"></vue-editor> 
                                </div>
                                <div class="w-fullbg-white rounded-sm">
                                    <div style="display: flex; gap: 16px; align-items: center;">
                                        <b-form-input v-model="fo.link" type="text" placeholder="Enter button link"></b-form-input>
                                        <b-button style="height: 38px;" v-b-modal.bv-modal-blog-xl @click="getBlog(fo)">Select</b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style="display: flex; gap: 16px;">
                        <h6 style="padding-top: 5px;">Footer Background Color Visibility:</h6>
                        <div v-if="footerColor" @click="footerColor = false" style="background-color: #82868B; color: #ffffff; padding: 4px; height: 27px; cursor: pointer; border-radius: 4px;">Hide</div>
                        <div v-else @click="footerColor = true" style="background-color: #0397d6; color: #ffffff; padding: 4px; height: 27px; cursor: pointer; border-radius: 4px;">Visible</div>
                    </div>

                    <div style="display: flex; gap: 16px;">
                        <b-button style="height: 40px;" @click="submitTemplate" variant="primary">Save Newsletter</b-button>
                    </div>
                </div>

                <div class="main-demo-layout">
                    <div style="width: 100%; display: flex; justify-content: end; margin-bottom: 20px;">
                        <div style="display: flex; gap: 12px;">
                            <b-button variant="secondary" @click="downloadPDF">Download as PDF</b-button>
                            <b-button variant="primary" @click="sendEmail">Send Email</b-button>
                        </div>
                    </div>
                    
                    <div style="display: flex; width: 100%; justify-content: center;">
                        <div style="width: 100%;">
                            <div>
                                <html>
                                    <head></head>
                                    <div id="emailtemplate">
                                        <body>
                                            <table style="background-color: #E4E4E4;" align="center">
                                                <tbody>
                                                    <tr>
                                                        <td style="width: 20px;"> </td>
                                                        <td style="width: 600px; background-color: #ffffff;">
                                                            <table id="download-section">
                                                                <tbody>
                                                                    <tr>
                                                                        <td style="width: 100%"> 
                                                                            <div>
                                                                                <!-- HEADER -->
                                                                                <div>
                                                                                    <img width="600" :src="settings.image" alt="">
                                                                                </div> 
                                                                                <br />

                                                                                <!-- BODY -->
                                                                                <div style="width: 600px;" v-for="(fo, index) in layouts" :key="index">
                                                                                    <div v-if="fo.template == 1">
                                                                                        <table id="basic-email" width="600">
                                                                                            <tbody>
                                                                                                <tr>
                                                                                                    <td style="width: 20px;"> </td>
                                                                                                    <td style="width: 560px;">
                                                                                                        <div>
                                                                                                            <div style="display: flex; align-items: left;">
                                                                                                                <span v-if="fo.title" class="roboto" style="font-weight: 600; text-align: left; color: #0397d6; line-height: 2rem;">
                                                                                                                    {{ fo.title }}
                                                                                                                </span>
                                                                                                            </div>
                                                                                                            <div v-if="fo.details">
                                                                                                                <br />
                                                                                                                <div class="calibri" style="font-size: 13px; text-align: left; color: #1E1E1E;">
                                                                                                                    <span v-html="fo.details"></span>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div v-if="fo.link">
                                                                                                                <br />
                                                                                                                <div style="text-align: left;">
                                                                                                                    <div style="text-align: left;">
                                                                                                                        <a :href="fo.link" target="_blank"><img src="https://api-newsletter-unwomen.smicee.com/media/read-more.png" alt=""></a>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <br />
                                                                                                    </td>
                                                                                                    <td style="width: 20px;"> </td>
                                                                                                </tr>
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </div>
                                                                                    <div v-if="fo.template == 2">
                                                                                        <table id="basic-email" width="600">
                                                                                            <tbody>
                                                                                                <tr>
                                                                                                    <td style="width: 20px;"> </td>
                                                                                                    <td style="width: 560px;">
                                                                                                        <div>
                                                                                                            <div v-if="fo.title">
                                                                                                                <div style="text-align: left;">
                                                                                                                    <span class="roboto" style="font-weight: 600; text-align: left; color: #0397d6; line-height: 2rem;">{{ fo.title }}</span>
                                                                                                                </div>
                                                                                                                <br />
                                                                                                            </div>
                                                                                                            <div style="overflow: hidden;">
                                                                                                                <div style="float: right; margin-left: 16px;">
                                                                                                                    <div>
                                                                                                                        <img width="230" :src="fo.image" alt="">
                                                                                                                        <div style="max-width: 200px; word-wrap: break-word; color: #1E1E1E;">
                                                                                                                            <i class="calibri" style="font-size: 11px; margin-top: 2px;">{{ fo.caption }}</i>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div v-if="fo.details" class="calibri" style="font-size: 13px; text-align: left; color: #1E1E1E;">
                                                                                                                    <span v-html="fo.details"></span>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div v-if="fo.link">
                                                                                                                <br />
                                                                                                                <div style="text-align: left;">
                                                                                                                    <a :href="fo.link" target="_blank"><img src="https://api-newsletter-unwomen.smicee.com/media/read-more.png" alt=""></a>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <br />
                                                                                                    </td>
                                                                                                    <td style="width: 20px;"> </td>
                                                                                                </tr>
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </div>
                                                                                    <div v-else-if="fo.template == 3">
                                                                                        <table id="basic-email" width="600">
                                                                                            <tbody>
                                                                                                <tr>
                                                                                                    <td style="width: 20px;"> </td>
                                                                                                    <td style="width: 560px;">
                                                                                                        <div>
                                                                                                            <div v-if="fo.title">
                                                                                                                <div>
                                                                                                                    <span class="roboto" style="width: 100%; font-weight: 600; text-align: left; color: #0397d6; line-height: 2rem;">{{ fo.title }}</span>
                                                                                                                </div>
                                                                                                                <br />
                                                                                                            </div>
                                                                                                            <div style="overflow: hidden;">
                                                                                                                <div style="float: left; margin-right: 16px;">
                                                                                                                    <div>
                                                                                                                        <img width="230" :src="fo.image" alt="">
                                                                                                                        <div style="max-width: 200px; word-wrap: break-word; color: #1E1E1E;">
                                                                                                                            <i class="calibri" style="font-size: 11px; margin-top: 2px;">{{ fo.caption }}</i>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div v-if="fo.details" class="calibri" style="font-size: 13px; text-align: left; color: #1E1E1E;">
                                                                                                                    <span v-html="fo.details"></span>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div v-if="fo.link">
                                                                                                                <br />
                                                                                                                <div style="text-align: left;">
                                                                                                                    <a :href="fo.link" target="_blank"><img src="https://api-newsletter-unwomen.smicee.com/media/read-more.png" alt=""></a>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <br />
                                                                                                    </td>
                                                                                                    <td style="width: 20px;"> </td>
                                                                                                </tr>
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </div> 
                                                                                    <div v-else-if="fo.template == 4">
                                                                                        <table id="basic-email" width="600">
                                                                                            <tbody>
                                                                                                <tr>
                                                                                                    <td style="width: 26px;"> </td>
                                                                                                    <td style="width: 548px;">
                                                                                                        <div>
                                                                                                            <div>
                                                                                                                <div>
                                                                                                                    <div v-if="fo.title">
                                                                                                                        <div style="text-align: left;">
                                                                                                                            <span class="roboto" style="font-weight: 600; text-align: left; color: #0397d6; line-height: 2rem;">{{ fo.title }}</span>
                                                                                                                        </div>
                                                                                                                        <br />
                                                                                                                    </div>
                                                                                                                    <div>
                                                                                                                        <img width="547" :src="fo.image" alt="">
                                                                                                                        <div style="max-width: 90%; word-wrap: break-word; color: #1E1E1E;"> 
                                                                                                                            <i class="calibri" style="font-size: 11px; margin-top: 2px;">{{ fo.caption }}</i>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                    <div v-if="fo.details">
                                                                                                                        <br />
                                                                                                                        <div class="calibri" style="font-size: 13px; text-align: left; color: #1E1E1E;">
                                                                                                                            <span v-html="fo.details"></span>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                    <div v-if="fo.link">
                                                                                                                        <br />
                                                                                                                        <div style="text-align: left;">
                                                                                                                            <a :href="fo.link" target="_blank"><img src="https://api-newsletter-unwomen.smicee.com/media/read-more.png" alt=""></a>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <br />
                                                                                                    </td>
                                                                                                    <td style="width: 26px;"> </td>
                                                                                                </tr>
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </div>
                                                                                    <div v-else-if="fo.template == 5">
                                                                                        <table id="basic-email" width="600">
                                                                                            <tbody>
                                                                                                <tr>
                                                                                                    <td style="width: 26px;"> </td>
                                                                                                    <td style="width: 548px;"> 
                                                                                                        <div>
                                                                                                            <div>
                                                                                                                <div>
                                                                                                                    <div v-if="fo.title">
                                                                                                                        <div style="text-align: left;">
                                                                                                                            <span class="roboto" style="font-weight: 600; text-align: left; color: #0397d6; line-height: 2rem;">{{ fo.title }}</span>
                                                                                                                        </div>
                                                                                                                        <br />
                                                                                                                    </div>
                                                                                                                    <div v-if="fo.details" class="calibri" style="font-size: 13px; text-align: left; color: #1E1E1E;">
                                                                                                                        <span v-html="fo.details"></span>
                                                                                                                    </div>
                                                                                                                    <div v-if="fo.link">
                                                                                                                        <br />
                                                                                                                        <div style="text-align: left;">
                                                                                                                            <a :href="fo.link" target="_blank"><img src="https://api-newsletter-unwomen.smicee.com/media/read-more.png" alt=""></a>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <br />
                                                                                                            <div>
                                                                                                                <img width="547" :src="fo.image" alt="">
                                                                                                                <div style="max-width: 90%; word-wrap: break-word; color: #1E1E1E;"> 
                                                                                                                    <i class="calibri" style="font-size: 11px; margin-top: 2px;">{{ fo.caption }}</i>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <br />
                                                                                                    </td>
                                                                                                    <td style="width: 26px;"> </td>
                                                                                                </tr>
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </div>
                                                                                    <!-- <div v-else>
                                                                                        <div>
                                                                                            <div style="padding: 20px;">
                                                                                                <p style="font-weight: 500; font-size: large; text-align: center; padding-top: 20px;">No Preview to Show!</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div> -->
                                                                                </div>

                                                                                <!-- FOOTER -->
                                                                                <div style="width: 600px;">
                                                                                    <div style="width: 600px; height: 100%; background-color: #0397d6; color: #ffffff;" v-if="footerColor">
                                                                                        <br />
                                                                                        <div>
                                                                                            <table width="600" style="background-color: #0397d6; color: #ffffff;">
                                                                                                <tbody>
                                                                                                    <tr>
                                                                                                        <td style="width: 2%;"> </td>
                                                                                                        <td align="left">
                                                                                                            <div class="calibri">
                                                                                                                <div v-if="settings.country_office">
                                                                                                                    <img width="14" height="14" src="https://api-newsletter-unwomen.smicee.com/media/white-location.png" alt=""><span style="padding-left: 8px;">{{ settings.country_office }}</span>
                                                                                                                </div> 

                                                                                                                <div v-if="settings.phone" style="margin-top: 8px;">
                                                                                                                    <img width="13" height="13" src="https://api-newsletter-unwomen.smicee.com/media/white-phone.png" alt=""><span style="padding-left: 8px; ">{{ settings.phone }}</span>
                                                                                                                </div>

                                                                                                                <div v-if="settings.website" style="margin-top: 8px; word-break: break-all;"><img width="14" height="14" src="https://api-newsletter-unwomen.smicee.com/media/white-link.png" alt=""><span style="padding-left: 8px;">{{ settings.website }}</span></div>
                                                                                                            
                                                                                                                <div v-if="settings.fb_link" style="margin-top: 8px; word-break: break-all;"><img width="13" height="13" src="https://api-newsletter-unwomen.smicee.com/media/white-fb.png" alt=""><span style="padding-left: 8px;">{{ settings.fb_link }}</span></div>

                                                                                                                <div style="overflow: hidden;">
                                                                                                                    <div style="float: right; margin-right: 6px; margin-bottom: 14px;">
                                                                                                                        <img src="https://api-newsletter-unwomen.smicee.com/media/logo-white.png" alt="">
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </td>
                                                                                                        <td style="width: 2%;"> </td>
                                                                                                    </tr>
                                                                                                </tbody>
                                                                                            </table>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div v-else>
                                                                                        <div style="width: 600px;">
                                                                                            <table width="600">
                                                                                                <tbody>
                                                                                                    <tr>
                                                                                                        <td style="width: 2%;"> </td>
                                                                                                        <td align="left">
                                                                                                            <br />
                                                                                                            <div class="calibri">
                                                                                                                <div v-if="settings.country_office">
                                                                                                                    <img width="18" height="18" src="https://api-newsletter-unwomen.smicee.com/media/location.jpg" alt=""><span style="padding-left: 8px;">{{ settings.country_office }}</span>
                                                                                                                </div>

                                                                                                                <div v-if="settings.phone" style="margin-top: 8px;"><img width="18" height="18" src="https://api-newsletter-unwomen.smicee.com/media/phone.jpg" alt=""><span style="padding-left: 8px;">{{ settings.phone }}</span></div>

                                                                                                                <div v-if="settings.website" style="margin-top: 8px; word-break: break-all;"><img width="18" height="18" src="https://api-newsletter-unwomen.smicee.com/media/link.jpg" alt=""><span style="padding-left: 8px;">{{ settings.website }}</span></div>

                                                                                                                <div v-if="settings.fb_link" style="margin-top: 8px; word-break: break-all;"><img width="18" height="18" src="https://api-newsletter-unwomen.smicee.com/media/fb.jpg" alt=""><span style="padding-left: 8px;">{{ settings.fb_link }}</span></div>

                                                                                                                <div style="overflow: hidden;">
                                                                                                                    <div style="float: right; margin-right: 6px; margin-bottom: 14px;">
                                                                                                                        <img src="https://api-newsletter-unwomen.smicee.com/media/logo.png" alt="">
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </td>
                                                                                                        <td style="width: 2%;"> </td>
                                                                                                    </tr>
                                                                                                </tbody>
                                                                                            </table>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                        <td style="width: 20px;"> </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </body>
                                    </div>
                                </html>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- MODAL -->
        <b-modal id="bv-modal-example-xl" size="xl" hide-footer>
            <template #modal-title>
               Select
            </template> 
            <div>
                <div class="d-block text-center"> 
                    <div class="full-content">
                        <div class="upload-content border-style">
                            <div style="width: 100%; display: flex; flex-direction: column; align-items: start;">
                                <img v-if="demo_image" style="height: 120px; max-width: 100%; margin-bottom: 24px;" :src="demo_image" alt="">
                                <input type="file" accept="image/*" @change="uploadAttachment">
                                <b-form-input style="margin-top: 24px;" v-model="image.title" type="text" placeholder="Enter title"></b-form-input>
                                <b-button style="margin-top: 24px;" variant="primary" @click="submitContent">Upload</b-button>
                            </div>
                        </div>
                        <div style="width: 100%;">
                            <div class="task-board-task-scroll">
                                <div class="image-content border-style" style="height: 100%; width: 100%; overflow-y: auto;">
                                    <div class="content-grid-view">
                                        <div v-for="image, index in image_contents" :key="index">
                                            <div @click="selectImage(image)" style="height: 160px;">
                                                <img class="content-size" style="max-height: 160px; object-fit: contain;" :src="image.image" alt="">
                                            </div>
                                            <p @click="selectImage(image)" style="margin-top: 6px;">{{ image.title }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

        <!-- MODAL -->
        <b-modal id="bv-modal-blog-xl" size="xl" hide-footer>
            <template #modal-title>
               Select
            </template>
            <div>
                <div class="d-block text-center"> 
                    <div class="full-content">
                        <div class="upload-content border-style">
                            <div style="width: 100%; display: flex; flex-direction: column; align-items: start;">
                                <input type="file" @change="uploadBlogAttachment"> 
                                <b-form-input style="margin-top: 24px;" v-model="blog.title" type="text" placeholder="Enter title"></b-form-input>
                                <b-button style="margin-top: 24px;" variant="primary" @click="submitBlog">Upload</b-button>
                            </div>
                        </div>
                        <div style="width: 100%;">
                            <div class="task-board-task-scroll">
                                <div class="image-content border-style" style="height: 100%; width: 100%; overflow-y: auto;">
                                    <div class="content-grid-view">
                                        <div v-for="blog, index in blog_contents" :key="index">
                                            <div v-if="blog.file !== null">
                                                <div style="display: flex; height: 160px;" @click="selectBlog(blog)">
                                                    <div v-if="getFileExtension(blog.file) == 'jpg' || getFileExtension(blog.file) == 'png' || getFileExtension(blog.file) == 'jpeg' || getFileExtension(blog.file) == 'svg' || getFileExtension(blog.file) == 'gif'">
                                                        <img class="blog-size" style="max-height: 160px; object-fit: contain;" :src="host + blog.file" alt="">
                                                    </div>
                                                    <div v-else>
                                                        <img class="blog-size" style="max-height: 160px; object-fit: contain;" :src="fileImage" alt="">
                                                    </div>
                                                </div>
                                                <p @click="selectBlog(blog)" style="margin-top: 6px; text-align: left;">{{ blog.title }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </b-card>
</template>
  
<script>
import { BAvatar,BButton, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BFormSelectOption, BDropdown, BDropdownItem, BCard,
BModal,VBModal,BCardText, BFormTextarea, BCalendar, BFormDatepicker } from 'bootstrap-vue';
import store from '@/store/index';
import Ripple from "vue-ripple-directive";
import { mapState } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import fileImage from '../../../../assets/images/templates/file-thumbnail.png'; 
import { VueEditor } from "vue2-editor"; 
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

export default {
    components: {
        BAvatar,
        BCard,
        BBadge,
        BButton,
        BPagination,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BFormSelectOption,
        BDropdown,
        BDropdownItem,
        BModal,
        BCardText,
        BFormTextarea,
        BCalendar,
        BFormDatepicker,
        VueEditor
    },

    directives: {
        'b-modal': VBModal,
        Ripple,
    },

    computed: {
        ...mapState('content', ["contents_without_pg", "settings", "template_detail", "contentError", "contentLoading"]),
        ...mapState('blogs', ["blogs_without_pg","blogError","blogLoading"]),

        direction() {
            if (store.state.appConfig.isRTL) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.dir = true
                return this.dir
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.dir = false
            return this.dir
        }
    },

    watch: {
        contents_without_pg(newValue, oldValue) {
            this.image_contents = this.contents_without_pg
        },

        blogs_without_pg(newValue, oldValue) {
            this.blog_contents = this.blogs_without_pg
        },

        template_detail(newValue, oldValue) {
            this.layouts = this.template_detail.value
            this.subject = this.template_detail.subject
            this.footerColor = this.template_detail.footerColor
        }
    },

    created() {
        this.$store.dispatch('content/fetchSettings')
        this.image_contents = this.contents
        this.$store.dispatch('content/fetchTemplateDetails', this.$route.params.id)
        this.layouts = this.template_detail.value
        this.subject = this.template_detail.subject
        this.footerColor = this.template_detail.footerColor
        this.$store.dispatch('content/fetchContentWithoutPG', {
            start_date: this.content_start_date !== null ? this.content_start_date : null,
            end_date: this.content_end_date !== null ? this.content_end_date : null
        })
        this.image_contents = this.contents_without_pg
        this.$store.dispatch('blogs/fetchBlogWithoutPG', {
            start_date: this.blog_start_date !== null ? this.blog_start_date : null,
            end_date: this.blog_end_date !== null ? this.blog_end_date : null
        })
        this.blog_contents = this.blogs_without_pg
    },

    data() {
        return {
            test: true,
            host: 'https://api-newsletter-unwomen.smicee.com',
            selected_image: null,
            nameState: null,
            dir: false,
            rows: [],
            searchTerm: '',
            footerColor: true,
            viewPreview: false,
            hideTemplate: false,
            header: null,
            subject: null,
            layouts: [
                {
                    template: null,
                    caption: '',
                    title: '',
                    details: '',
                    link: '',
                    image: null
                }
            ],
            options: [
                {
                    title: 'Select a template',
                    value: 'null',
                    disabled: true
                },
                {
                    title: 'Template - 1 (Outlook)',
                    value: '1'
                },
                {
                    title: 'Template - 2',
                    value: '2'
                },
                {
                    title: 'Template - 3',
                    value: '3'
                },
                {
                    title: 'Template - 4 (Outlook)',
                    value: '4'
                },
                {
                    title: 'Template - 5 (Outlook)',
                    value: '5'
                }
            ],
            image: {
                image: null,
                title: ''
            },
            blog: {
                file: null,
                title: ''
            },
            image_contents: [],
            blog_contents: [],
            selectedImage: null,
            selectedBlog: null,
            body: null,
            innerhtml: null,
            demo_image: null,
            fileImage: fileImage,
            content_start_date: null,
            content_end_date: null,
            blog_start_date: null,
            blog_end_date: null
        }
    },

    methods: {
        async downloadPDF() {
            try {
                const element = document.querySelector('#download-section');
                if (!element) {
                    console.error("Element with ID 'download-section' not found!");
                    return;
                }

                element.classList.add('pdf-export');

                // Limit content length for testing (Optional: You can remove this if not needed)
                const rows = document.querySelectorAll('#basic-email > tbody > tr');
                rows.forEach((row, index) => {
                    if (index > 10) row.style.display = 'none';
                });

                // Handle image breaks before generating PDF
                this.preventImageBreaks();

                // Force re-render to apply page breaks
                await new Promise((resolve) => requestAnimationFrame(resolve));

                // Initialize jsPDF
                const pdf = new jsPDF({
                    orientation: 'portrait',
                    unit: 'px',
                    format: [600, 841], // 600px width, A4 height in px (≈ 841px)
                    compress: true
                });

                await pdf.html(element, {
                    callback: (pdf) => {
                        const filename = 'UN_WOMEN_Newsletter.pdf';

                        const pdfBlob = pdf.output('blob');

                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(pdfBlob);
                        link.download = filename;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);

                        setTimeout(() => {
                            URL.revokeObjectURL(link.href);
                        }, 100);

                        element.classList.remove('pdf-export');
                    },
                    margin: [30, 0, 30, 0],  // Minimal margins
                    autoPaging: 'text',      // Text is automatically managed
                    x: 0,                    // Start at the edge
                    width: 600,              // Match the exact content width
                    windowWidth: 600         // Match the content width exactly
                });

                console.log('After pdf.html() - PDF should have been saved');
            } catch (error) {
                console.error('Error generating PDF:', error);
            }
        },

        preventImageBreaks() {
            const max_page_height = 841; // A4 height in pixels

            // Get all images within the download section
            const images = document.querySelectorAll('#download-section img');
            console.log('Image count:', images.length);

            images.forEach((img) => {
                const rect = img.getBoundingClientRect();
                const imgTop = rect.top + window.scrollY;
                const imgHeight = rect.height;
                const imgBottom = imgTop + imgHeight;
                console.log('image top >>', imgTop, img.src)
                console.log('image height >>', imgHeight)
                // Calculate the space remaining on the current page
                const spaceRemaining = max_page_height - (imgTop % max_page_height);

                console.log('space >>', spaceRemaining)

                // Check if the image would be cut off by the page height
                if (imgHeight > spaceRemaining) { 
                    console.log('Image would break, moving to next page:', img.src);

                    // Create a page break before the image
                    const pageBreak = document.createElement('div');
                    pageBreak.className = 'page-break';
                    pageBreak.style.pageBreakBefore = 'always';
                    pageBreak.style.display = 'block';
                    pageBreak.style.clear = 'both'; 
                    pageBreak.style.height = '0';
                    pageBreak.style.margin = '0';
                    pageBreak.style.padding = '0';

                    // Insert the page break before the image
                    img.before(pageBreak);

                    // Optional: Add extra spacing for better layout
                    img.style.marginTop = `${spaceRemaining}px`;
                }
            });

            console.log('preventImageBreaks() completed successfully');
        },

        testToggle(){
            if(this.test) {
                this.test = false
            }else{
                this.test = true
            }
        },

        getFileExtension(link) {
            // Split the link by dots
            const parts = link.split('.');
            // Get the last part (which is the extension)
            const extension = parts[parts.length - 1];
            return extension;
        },

        getImage(fo) {
            fo.image = null
            this.selectedImage = fo
        },

        selectImage(img) {
            this.testToggle()
            this.selectedImage.image = img.image
            this.$nextTick(() => {
                this.$bvModal.hide('bv-modal-example-xl')
            })
            this.testToggle()
        },

        getBlog(fo) {
            fo.link = ''
            this.selectedBlog = fo
        },

        selectBlog(blog) {
            this.testToggle()
            this.selectedBlog.link = this.host + blog.file
            this.$nextTick(() => {
                this.$bvModal.hide('bv-modal-blog-xl')
            })
            this.testToggle()
        },

        uploadBlogAttachment(e) {
            this.blog.file = e.target.files[0]
        },

        submitBlog() {
            this.$store.dispatch('blogs/addBlogFromPG', this.blog).then(result=>{
                if(result.code == 200) {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: `Success`,
                            icon: 'ThumbsUpIcon',
                            variant: 'success',
                            text: result.response,
                        },
                    })

                    this.blog.file = null
                    this.blog.title = ''
                } else {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: `Error`,
                            icon: 'ThumbsUpIcon',
                            variant: 'error',
                            text: result.response,
                        }
                    })
                }
            })
        },

        addField(value, fieldType) {
            fieldType.push({value: ""});
        },
    
        removeField(index, fieldType) {
            fieldType.splice(index, 1);
        },

        moveItemUp(index) {
            if (index > 0) {
                const temp = this.layouts[index];
                this.layouts[index] = this.layouts[index - 1];
                this.layouts[index - 1] = temp;
            }
        },

        moveItemUp(index) {
            if (index > 0) {
                const temp = this.layouts[index];
                this.layouts.splice(index, 1);
                this.layouts.splice(index - 1, 0, temp);
            }
        },

        moveItemDown(index) {
            if (index < this.layouts.length - 1) {
                const temp = this.layouts[index];
                this.layouts.splice(index, 1);
                this.layouts.splice(index + 1, 0, temp);
            }
        },

        uploadAttachment(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e =>{
                this.image.image = e.target.result;
                this.demo_image = e.target.result;
            };
        },

        submitTemplate() {
            this.innerhtml = document.getElementById('emailtemplate').innerHTML;

            this.$store.dispatch('content/updateLayout', {subject: this.subject, footerColor: this.footerColor, value: this.layouts, inner_html: this.innerhtml, id: this.$route.params.id}).then(result=>{
                if(result.code == 200) {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: `Success`,
                            icon: 'ThumbsUpIcon',
                            variant: 'success',
                            text: result.response
                        }
                    })

                    setTimeout(() => {
                        this.$router.push('/newsletters')
                    }, 3000)
                }
            })
        },

        sendEmail() {
            this.body = `<html><head></head>` + document.getElementById('emailtemplate').innerHTML + `</html>`;

            this.$store.dispatch('content/sendMail', {subject: this.subject, body: this.body}).then(result=>{
                if(result.code == 200) {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: `Success`,
                            icon: 'ThumbsUpIcon',
                            variant: 'success',
                            text: result.response,
                        }
                    })
                }
            })
        },

        submitContent() {
            this.$store.dispatch('content/addContentFromPG', this.image).then(result=>{
                if(result.code == 200) {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: `Success`,
                            icon: 'ThumbsUpIcon',
                            variant: 'success',
                            text: result.response,
                        },
                    })

                    this.image.image = null
                    this.image.title = ''
                    
                } else {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: `Error`,
                            icon: 'ThumbsUpIcon',
                            variant: 'error',
                            text: result.response,
                        }
                    })
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap');

.roboto {
  font-family: "Roboto", serif;
  font-optical-sizing: auto;
  font-size: 15px;
}

.calibri {
  font-family: "Calibri", sans-serif;
  font-optical-sizing: auto;
}

.pdf-export {
    width: 640px;
    overflow: hidden;
    margin: 0 auto;
}

.page-break {
    page-break-before: always;
    display: block;
    height: 0;
    visibility: hidden;
    clear: both;
}

.vue-editor .ql-editor a {
  color: #0397d6;
}

.task-board-task-scroll {
    position: relative;
    height: 87.8vh;
}

.main-div-layout {
    width: 100%;
    display: flex;
    gap: 24px;
}

.big-screen-width {
    width: 70%;
}

.section-screen {
    width: 90%;
}

.main-template-layout {
    width: 60%;
    display: grid;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    gap: 40px;
}

.main-demo-layout {
    width: 40%;
}

.content-container {
    overflow: hidden; /* Clearfix for floats */
}

.image-container4 {
    float: left;
    margin-right: 16px;  
}

.content-grid-view {
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

.content-size {
    width: 230px;
}

.imageStyle {
    background-size: cover;
    object-fit: cover;
    width: 100%;
}

.full-content {
    width: 100%;
    display: flex;
    gap: 16px;
}

.border-style {
    border: 1px solid;
    padding: 16px;
    border-radius: 5px;
    border-color: rgb(211, 211, 211);
}

.upload-content {
    width: 30%;
}

.image-content {
    width: 70%;
}

/* height */
::-webkit-scrollbar {
    height: 6px;
    width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #555;
}

@media screen and (max-width: 1470px) {
    .content-grid-view {
        display: grid; 
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 24px; 
    }

    .content-size {
        width: 270px;
    }

    .main-div-layout {
        gap: 0px;
    }

    .main-template-layout {
        width: 50%;
    }

    .main-demo-layout {
        width: 50%;
    }
}

@media screen and (max-width: 1230px) {
    .content-size {
        width: 230px;
    }
}

@media screen and (max-width: 1199px) {
    .content-grid-view {
        display: grid; 
        grid-template-columns: repeat(1, minmax(0, 1fr));
        gap: 24px; 
    }

    .content-size {
        width: 210px;
    }

    .upload-content {
        width: 50%;
    }

    .image-content {
        width: 50%;
    }
}

@media screen and (max-width: 991px) {
    .full-content {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 32px;
    }

    .upload-content {
        width: 100%;
    }

    .image-content {
        width: 100%;
    }

    .content-grid-view {
        display: grid; 
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 24px; 
    }

    .content-size {
        width: 200px;
    }

    .main-div-layout {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    .big-screen-width {
        width: 100%;
    }

    .section-screen {
        width: 100%;
    }

    .main-template-layout {
        width: 100%;
    }

    .main-demo-layout {
        width: 100%;
    }
}

@media screen and (max-width: 835px) {
    .content-grid-view {
        display: grid; 
        grid-template-columns: repeat(1, minmax(0, 1fr));
        gap: 24px; 
    }

    .content-size {
        width: 250px;
    }
}

@media screen and (max-width: 430px) {
    .content-size {
        width: 100%;
    }
}
</style>